@if (isChatOpen===true) {
  <div id="close-chatbot-invisible-layer" (click)="closeChat()">
  </div>
}
<ion-row class="chatbot-bubble-row" (click)="closeChat()">
  <ion-col size="9" size-md="10" class="display-grid" (click)="closeChat()">
    @if (isChatOpen===true) {
      <form [formGroup]="chatForm" id="chat-window" class="chat-window"
        (click)="$event.stopPropagation()">
        <div class="flex chatbot-header">
          <strong class="ion-margin-start align-self-center">Helfer</strong>
          <ion-text class="beta-icon ion-margin-start ion-align-items-center display-flex">beta</ion-text>
          <button id="chat-close-button" class="close-button" (click)="closeChat()">
            <ion-icon name="close"></ion-icon>
          </button>
        </div>
      <ion-card class="card-tabs margin-padding-0 border-radius-0
        box-shadow-none">
          <!--<ion-segment [swipeGesture]="false" [value]="currentChatBotTab">
          <ion-segment-button (click)="changeChatBotTab($any($event.target).value)" [value]="messageType.BotMessage">
            <ion-label class="margin-padding-0">
              {{ messageType.BotMessage }}
            </ion-label>
          </ion-segment-button>
          <ion-segment-button (click)="changeChatBotTab($any($event.target).value)" [value]="messageType.SystemMessage">
            <ion-label class="margin-padding-0">
              {{ messageType.SystemMessage }}
              @if (areSystemNotificationsUnread === true) {
                <ion-icon name="alert-circle"
                class="highlighted-text"></ion-icon>
              }
            </ion-label>
          </ion-segment-button>
        </ion-segment>-->
        <ion-card-header class="align-items-center display-flex margin-padding-0">
          <h4>
            {{ messageType.SystemMessage }}
            @if (areSystemNotificationsUnread === true) {
              <ion-icon name="alert-circle"
              class="highlighted-text"></ion-icon>
            }
          </h4>
        </ion-card-header>
      </ion-card>
      @if (currentChatBotTab === messageType.BotMessage) {
        <div id="chat-output">
          <!--hier landet der Chat-Output von Chatbot und User-->
        </div>
      }
      @if (currentChatBotTab === messageType.SystemMessage) {
        <div id="system-output">
          <!--hier landet der Chat-Output vom System-->
        </div>
      }
      @if (currentChatBotTab === messageType.BotMessage) {
        <ion-text class="chat-input">
          <ion-row class="border-top-1">
            @if (isUserAgreementAgreed === true) {
              <ion-col size="8">
                <ion-textarea maxlength="255" formControlName="userInputChat"
                  (keyup)="changeUserInput($any($event.target).value)" (keyup.enter)="triggerChatSend()">
                </ion-textarea>
              </ion-col>
            }
            @if (isUserAgreementAgreed !== true && isLoggedIn !== true) {
              <ion-col class="ion-justify-content-end display-grid"
                >
                <ng-container>
                  <ion-button class="ion-margin" (click)="yesButtonClicked()"
                    [disabled]="isUserAgreementAgreed === null">Einwilligen
                  </ion-button>
                </ng-container>
              </ion-col>
            }
            @if (isUserAgreementAgreed === true) {
              <ion-col class="justify-content-center align-items-center display-grid"
                size="4">
                <ion-button (click)="triggerChatSend()" [disabled]="chatForm.valid === false">
                  <ion-icon name="send"></ion-icon>
                </ion-button>
              </ion-col>
            }
          </ion-row>
        </ion-text>
      }
      @if (currentChatBotTab !== messageType.BotMessage) {
        <ion-text class="chat-input">
          <ion-row class="margin-top-1px">
            <ion-col>
              <ion-textarea [disabled]="true">
              </ion-textarea>
            </ion-col>
          </ion-row>
        </ion-text>
      }
    </form>
  }
</ion-col>
</ion-row>
